/**
 * The BrandEx-safe portfolio accent palette (keys match the API's
 * `AccentColourDto`). Each colour keeps white text at WCAG AA (≥ 4.5:1).
 */
export const ACCENT_COLOURS = {
  azure: "#1d64d8",
  indigo: "#4338ca",
  teal: "#0f766e",
  emerald: "#047857",
  violet: "#6d28d9",
  rose: "#be123c",
  amber: "#b45309",
  slate: "#334155",
} as const;

export type AccentKey = keyof typeof ACCENT_COLOURS;

export const ACCENT_KEYS = Object.keys(ACCENT_COLOURS) as AccentKey[];

/** The hex value for an accent key, falling back to azure. */
export function accentHex(key: string): string {
  return key in ACCENT_COLOURS ? ACCENT_COLOURS[key as AccentKey] : ACCENT_COLOURS.azure;
}
